
/* injects from baggage-loader */

export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

export const modalTypes = {
  USER_PROFILE_EDIT: 'USER_PROFILE_EDIT',
  USER_EDIT: 'USER_EDIT',
  USER_ADD: 'USER_ADD',
  INTEGRATION_ADD: 'INTEGRATION_ADD',
  INTEGRATION_UPLOAD: 'INTEGRATION_UPLOAD',
  SITE_ADD: 'SITE_ADD',
  SITE_DELETE_CONFIRM: 'SITE_DELETE_CONFIRM',
  HELP_SHOW: 'HELP_SHOW',
  NOTIFY_SHOW: 'NOTIFY_SHOW',
  REPORT_ADD: 'REPORT_ADD',
  REPORT_DELETE_CONFIRM: 'REPORT_DELETE_CONFIRM',
  CHANNEL_SELECTOR: 'CHANNEL_SELECTOR',
  PAYMENT_DETAILS: 'PAYMENT_DETAILS',
  PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM: 'PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM',
  PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM: 'PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM',
  INTEGRATIONS_NEW_SPREADSHEET: 'INTEGRATIONS_NEW_SPREADSHEET',
  INTEGRATIONS_NEW_MANUAL_INPUT: 'INTEGRATIONS_NEW_MANUAL_INPUT',
  INTEGRATIONS_NEW_CRITEO: 'INTEGRATIONS_NEW_CRITEO'
}

const initialState = {
  modalType: null,
  modalProps: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps
      }
    case HIDE_MODAL:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/modal/index.js